import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { SystemService } from '../shared/service/system/system.service';

@Injectable({ providedIn: 'root' })
export class SupportViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);


  async canActivate(): Promise<boolean> {
    const ticketUrl = await this.systemService.createSupportCallForm();
    if (ticketUrl) {
      const popup = window.open(ticketUrl, '_blank');
      if (popup) {
        popup.focus();
      } else {
        console.warn('Popup blocked or failed to open support form URL.');
      }
    }
    return false;
  }
}
